export default __webpack_public_path__ + "static/media/pv-anillo.d0836e5b.jpg";